import uuid4 from 'uuid4'

export const download = (text, filename = uuid4(), encoding = 'utf-8') => {
  const blob = new Blob([text], {
    type: `text/plain;charset=${encoding};`,
    encoding
  })

  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveBlob(blob, `${filename}.txt`)
  } else {
    let a = window.document.createElement('a')
    a.href = window.URL.createObjectURL(blob)
    a.download = `${filename}.txt`
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
  }
}

export const readAsText = (inputFile, encoding = 'ascii') => {
  const tmpReader = new FileReader()

  return new Promise((resolve, reject) => {
    tmpReader.onerror = () => {
      tmpReader.abort()
      reject(new Error('Problem reading file'))
    }
    tmpReader.onload = () => {
      resolve(tmpReader.result)
    }

    tmpReader.readAsText(inputFile, encoding)
  })
}
